import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum CodeStatusEnum {
    DoNotResuscitate = 1,
    DoNotHospitalize = 2,
    DoNotIntubate = 4
}

export class CodeStatusEnumClass extends EnumWithDescription<CodeStatusEnum> {
    public readonly enum = CodeStatusEnum;
    public readonly enumName: string = "CodeStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<CodeStatusEnum>> = new Map([
        [
            "Do Not Resuscitate",
            {
                value: CodeStatusEnum.DoNotResuscitate,
                name: "DoNotResuscitate"
            }
        ],
        [
            "Do Not Hospitalize",
            {
                value: CodeStatusEnum.DoNotHospitalize,
                name: "DoNotHospitalize"
            }
        ],
        [
            "Do Not Intubate",
            {
                value: CodeStatusEnum.DoNotIntubate,
                name: "DoNotIntubate"
            }
        ]
    ]);
}

export const CodeStatus = new CodeStatusEnumClass();
